(function () {
  var SECTION_ID = 'sova-cart-drawer';
  var root = document.querySelector('[data-sova-drawer]');
  if (!root) return;

  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocused = null;

  function panel() { return root.querySelector('[data-sova-drawer-panel]'); }

  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    document.body.classList.add('sova-drawer-open');

    var closeBtn = root.querySelector('[data-sova-drawer-close]');
    if (closeBtn) window.setTimeout(function () { closeBtn.focus(); }, 60);
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('sova-drawer-open');
    var p = panel();
    if (p) p.style.transform = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function refresh(thenOpen) {
    return fetch(rootUrl + '?section_id=' + SECTION_ID, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sova-drawer]');
        if (!fresh) return;

        var wasOpen = root.classList.contains('is-open');
        root.innerHTML = fresh.innerHTML;
        bind();

        if (wasOpen || thenOpen) {
          root.classList.add('is-open');
          document.body.classList.add('sova-drawer-open');
        }

        updateBadge();
      })
      .catch(function () { window.location.reload(); });
  }

  function updateBadge() {
    fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.sova-cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        }
      })
      .catch(function () {});
  }

  function changeLine(line, quantity, item) {
    if (item) item.classList.add('is-updating');

    return fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .catch(function () { window.location.reload(); });
  }

  function addVariant(id, btn) {
    if (btn) {
      btn.classList.add('is-busy');
      btn.textContent = 'Adding…';
    }
    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () { return refresh(true); })
      .catch(function () {
        if (btn) { btn.classList.remove('is-busy'); btn.textContent = 'Add'; }
      });
  }

  function bindSwipe() {
    var p = panel();
    if (!p) return;

    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dragging = false;
    var decided = false;

    p.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      dragging = true;
      decided = false;
    }, { passive: true });

    p.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var x = e.touches[0].clientX;
      var y = e.touches[0].clientY;
      var deltaX = x - startX;
      var deltaY = y - startY;

      if (!decided) {
        if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) return;
        decided = true;
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          dragging = false;
          return;
        }
        p.classList.add('is-dragging');
      }

      dx = Math.max(0, deltaX);
      p.style.transform = 'translateX(' + dx + 'px)';
    }, { passive: true });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      p.classList.remove('is-dragging');
      p.style.transform = '';
      if (dx > p.offsetWidth * 0.3) close();
      dx = 0;
    }

    p.addEventListener('touchend', endDrag);
    p.addEventListener('touchcancel', endDrag);
  }

  function bind() {
    var overlay = root.querySelector('[data-sova-drawer-overlay]');
    if (overlay) overlay.addEventListener('click', close);

    root.querySelectorAll('[data-sova-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    root.querySelectorAll('[data-sova-drawer-line]').forEach(function (item) {
      var line = parseInt(item.getAttribute('data-sova-drawer-line'), 10);
      var qtyEl = item.querySelector('[data-sova-drawer-qty]');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;

      var up = item.querySelector('[data-sova-drawer-up]');
      var down = item.querySelector('[data-sova-drawer-down]');
      var remove = item.querySelector('[data-sova-drawer-remove]');

      if (up) up.addEventListener('click', function () { changeLine(line, current + 1, item); });
      if (down) down.addEventListener('click', function () { changeLine(line, Math.max(0, current - 1), item); });
      if (remove) remove.addEventListener('click', function () { changeLine(line, 0, item); });
    });

    root.querySelectorAll('[data-sova-drawer-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addVariant(btn.getAttribute('data-variant-id'), btn);
      });
    });

    bindSwipe();
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sova-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      refresh(true);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalHtml = submitBtn ? submitBtn.innerHTML : null;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Adding…';
    }

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () { return refresh(true); })
      .then(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHtml;
        }
      })
      .catch(function () {
        form.submit();
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();

    if (e.key === 'Tab' && root.classList.contains('is-open')) {
      var p = panel();
      if (!p) return;
      var focusables = p.querySelectorAll('a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  bind();
  updateBadge();
})();
